exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bgModalHeader{\n  background-color: #1c859a;\n  color: #FFFFFF;\n}\n.modal-content{\n  border-radius: 3rem;\n}\n", ""]);

// exports
